import { useTranslation } from "react-i18next";
import { CreateIntegrationButton } from "./CreateIntegrationButton";
import { SaveIntegrationButton } from "./SaveIntegrationButton";
import { DeleteIntegrationButton } from "./DeleteIntegrationButton";
import { Integration, IntegrationFormData } from "../../../api";
import { FormInstance } from "antd";

interface IntegrationActionsProps {
  selectedIntegration: { id: string; name: string };
  consumerId: string;
  integrations: Integration[];
  form: FormInstance<IntegrationFormData>;
}

export function IntegrationActions({
  selectedIntegration,
  consumerId,
  integrations,
  form,
}: IntegrationActionsProps) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
      data-testid="integration-actions"
    >
      <div style={{ display: "flex", gap: "1em", alignItems: "center" }}>
        <CreateIntegrationButton
          integrations={integrations}
          consumerId={consumerId}
        />
        <DeleteIntegrationButton
          name={selectedIntegration?.name}
          text={t("integrations:delete-integration")}
          disable={!selectedIntegration?.id}
          containerStyle={{ margin: "0em" }}
          buttonStyle={{ width: "200px", height: "40px" }}
        />
      </div>
      <div>
        <SaveIntegrationButton form={form} />
      </div>
    </div>
  );
}
